var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"skeleton-card",style:({
    background: _vm.primary,
    borderRadius: _vm.borderRadius,
    padding: _vm.padding
})},[(!_vm.animDisable)?_c('div',{staticClass:"skeleton-card-loader",style:({
    background: _vm.loaderBackground,
    animationDuration: _vm.animDuration,
    animationTimingFunction: _vm.animTimingFunction
  })}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }